import {EvalueringsstatistikFiltersState} from "../../../pages/evalueringsstatistik/evalueringsstatistikFiltersSlice";
import {CreateFilterInputModel} from "../../../core/components/filter/createFilterInputModel";
import {FilterType} from "../../../core/sharedmodels/filter/filterType";
import {toDate} from "../../../index";
import {RootTypeEnum} from "../../../core/sharedmodels/laegeInstitution/rootTypeEnum";

export class EvalueringsstatistikFilterInputModel {
    regioner?: string[];
    sygehuse?: string[];
    uddannelsessteder: string[];
    uddannelsestyper: string[];
    omraader?: string[];
    specialer?: string[];
    laegeinstitutionstype?: RootTypeEnum;
    filterType: FilterType;
    titel: string;
    id?: string;
    includeInactive: boolean;
    startDato: string;
    slutDato: string;
    constructor(filter: EvalueringsstatistikFiltersState, values: CreateFilterInputModel) {
        this.regioner = filter.regioner?.map(x => x.id) ?? [];
        this.sygehuse = filter.sygehuse?.map(x => x.id) ?? [];
        this.uddannelsessteder = filter.uddannelsessteder?.filter(x => x.selected)?.map(x => x.id) ?? [];
        this.omraader = filter.omraader?.map(x => x.id) ?? [];
        this.uddannelsestyper = filter.uddannelsestyper?.map(x => x.id) ?? [];
        this.specialer = filter.specialer?.map(x => x.id) ?? [];
        this.filterType = FilterType.EvalueringsstatistikFilter;
        this.laegeinstitutionstype = filter.laegeinstitutionstype;
        this.titel = values.titel;
        this.id = values.filterId;
        this.includeInactive = filter.includeInactive;
        this.startDato = filter.startDato ? toDate(filter.startDato).dateToApiPostFormat() : new Date().dateToApiPostFormat();
        this.slutDato = filter.slutDato ? toDate(filter.slutDato).dateToApiPostFormat() : new Date().dateToApiPostFormat();

    }
}

